import React from "react"
import { isMobile } from "react-device-detect"
import Hotspot from "./Hotspot"
import OutsideClickTrigger from "../../../helpers/components/OutsideClickTrigger"

const HotspotBanner = (props) => {
  let activeSpotData = isMobile ? props.mobileSpots : props.spots
  if (!activeSpotData || Object.keys(activeSpotData).length === 0) return ""

  let n = 0
  let spots = (
    <OutsideClickTrigger onOutsideClick={(e) => closeAllSpots(e)}>
      <React.Fragment>
        {activeSpotData.map((spot) => (
          <Hotspot key={n++} onClick={handleSpotClick} spot={spot}></Hotspot>
        ))}
      </React.Fragment>
    </OutsideClickTrigger>
  )

  return spots
}

const closeAllSpots = () => {
  let allSpots = document.querySelectorAll(".hotspot-content")
  allSpots.forEach((spot) => spot.classList.add("hidden"))
  allSpots.forEach((spot) => spot.parentElement.classList.remove("spotopen"))
}

const handleSpotClick = (e) => {
  let clickedDot = e.target.closest(".hotspot-dot")
  let clickedHotspot = clickedDot.parentElement
  let spotContent = clickedHotspot.querySelector(".hotspot-content")

  if (spotContent && spotContent.classList.contains("hidden")) {
    closeAllSpots()
    spotContent.classList.remove("hidden")
    clickedHotspot.classList.add("spotopen")
  } else {
    spotContent.classList.add("hidden")
    clickedHotspot.classList.remove("spotopen")
  }
}

export default HotspotBanner
